import { whiteColor } from 'theme/color';
import { displayInlineBlock, margin10 } from 'theme/common.style';

export const statusCard = {
  backgroundColor: whiteColor,
  // boxShadow: `0px 1px 8px ${lightShadow}`,
  boxShadow: `5px 5px 20px rgba(240, 240, 240, 0.25)`,
  height: '82px',
  // width:"441px",
  border: '2px solid #F0F0F0',
  borderRadius: '5px',
  alignItems: 'center',
};

export const statusText = {
  ...displayInlineBlock,
};

export const statusContent = {
  ...margin10,
  justifyContent: 'space-between',
  'align-items': 'center',
  display: 'flex',
  flexDirection: 'row',
  alignItem: 'center',
};
